import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Badge } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaDollarSign, FaEye } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, formatarValor, getCurrentUser, situacoesAgendamento, formatarValorLocal } from '../../common/utils';
import Paginacao from '../../common/pagination';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

class CreditoAntecipacao extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            beneficiario_id: "",
            page_numb: 1,
            dados_usuario: '',
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaRegistro(this.state.page_numb)
    }

    consultaRegistro(page_numb=1){
        const dados_user = getCurrentUser();

        this.setState({
            dados_usuario: dados_user
        })

        const url = `/credito-antecipacao/?page=${page_numb}`;

        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar os créditos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    // Retorna classe do Badge com base no status
    getBadgeVariant(status) {
        switch (status) {
            case 'pendente':
                return 'info';
            case 'aprovado':
                return 'success';
            case 'rejeitado':
                return 'warning';
            case 'cancelado':
                return 'danger';
            default:
                return 'secondary';
        }
    }

    // Coloca a primeira letra maiúscula
    capitalizeFirst(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {

            const dados_user = getCurrentUser();

            const now = moment().tz("America/Sao_Paulo"); // Data e hora atual no fuso horário de São Paulo

            return this.state.listRegistros.results.map((item) => {
                const badgeVariant = this.getBadgeVariant(item.status);
                const statusText = this.capitalizeFirst(item.status);
                return (
                    <tr key={item.id}>
                        <td data-label="ID">{item.id}</td>
                        <td>{formataDataHoraExibicao(item.data_criacao)}</td>
                        <td>{item.dados_programa.nome}</td>
                        <td>{item.dados_prestador.nome}</td>
                        <td>{item.dados_servico_procedimento.nome}</td>
                        <td>{item.quantidade_utilizada}/{item.quantidade}</td>
                        <td>
                            <Badge bg={badgeVariant}>
                                {statusText}
                            </Badge>
                        </td>
                        <td>{item.dados_faturamento.valor_total ? formatarValorLocal(item.dados_faturamento.valor_total) : 'R$ 0,00'}</td>
                        <td>
                            {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && this.state.dados_usuario['tipo_usuario'] !== 'beneficiario' && (
                                <>
                                    <Button variant="light" href={"/faturamentos/edit/"+item.dados_faturamento.id} size="sm" className="mt-1 mb-1">
                                        <FaDollarSign /> Faturamento
                                    </Button>
                                    <Button variant="light" href={"/creditosantecipacao/edit/"+item.id} size="sm"  className="mt-1 mb-1">
                                        <FaEye /> Visualizar
                                    </Button>
                                </>                                
                            )}  
                        </td>
                    </tr>
                );
            });
        }

        return (
            <tr>
                <td colSpan={10}>Nenhum crédito cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page)
    };

    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_user = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Créditos de Antecipação</h4>
                    </Col>
                    {this.state.dados_usuario['tipo_usuario'] != 'prestador' && this.state.dados_usuario['tipo_usuario'] != 'beneficiario' && (
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/creditosantecipacao/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Crédito
                        </Button>
                    </Col>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                {/*<Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaCliente}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Beneficiário"
                                                                aria-label="Beneficiário"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>*/}
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Data de Criação</th>
                                    <th>Programa</th>
                                    <th>Prestador</th>
                                    <th>Serviço/Procedimento</th>
                                    <th>Utilizado/Quantidade</th>
                                    <th>Status</th>
                                    <th>Valor Total</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={9}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={9}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(CreditoAntecipacao);